export default __webpack_public_path__ + "static/heuvel-c59edcdd5c5f5b9f3be99460cf4acc3e.jpg";